import React from 'react';
import {Redirect, Route, IndexRoute, IndexRedirect} from 'react-router';

import CreateAccounts from 'client/components/CreateAccounts/CreateAccounts.react';
import SchoolAdmin from 'client/SchoolAdministration/SchoolAdministration.react';
import SchoolList from 'client/SchoolAdministration/SchoolList/SchoolList.react';
import School from 'client/SchoolAdministration/School/School.react';
import SchoolAdminDashboard from 'client/SchoolAdministration/School/Dashboard/Dashboard.react';
import SchoolAdminManageStaff from 'client/SchoolAdministration/School/ManageStaff/ManageStaff.react';
import SchoolAccounts from 'client/SchoolAdministration/School/SchoolAccounts/SchoolAccounts.react';
import SchoolAdminPendingApprovalStaff from 'client/SchoolAdministration/School/ManageStaff/Staff/PendingApproval.react';
import SchoolAdminPendingInvitationsStaff from 'client/SchoolAdministration/School/ManageStaff/Staff/PendingInvitations.react';
import SchoolAdminApprovedStaff from 'client/SchoolAdministration/School/ManageStaff/Staff/Approved.react';
import SchoolAdminRejectedStaff from 'client/SchoolAdministration/School/ManageStaff/Staff/Rejected.react';
import SchoolAdminUpdateTeachers from 'client/SchoolAdministration/School/ManageStaff/Staff/UpdateTeachers/UpdateTeachers.react';
import SchoolAdminUsageReports from 'client/SchoolAdministration/School/UsageReports/UsageReports.react';
import SchoolAdminTeachersReport from 'client/SchoolAdministration/School/UsageReports/Reports/TeachersReport.react';
import SchoolAdminStudentsReport from 'client/SchoolAdministration/School/UsageReports/Reports/StudentsReport.react';
import SchoolAdminClassesReport from 'client/SchoolAdministration/School/UsageReports/Reports/ClassesReport.react';
import SchoolAdminSubjectsReport from 'client/SchoolAdministration/School/UsageReports/Reports/SubjectsReport.react';

export default (
  <Route path='school-admin' component={SchoolAdmin} title='School Administration | Albert.io'>
    <IndexRoute component={SchoolList} />
    <Route component={School} path=':schoolId' title='School Administration | Albert.io'>
      <IndexRedirect to='dashboard' />
      <Route component={SchoolAdminDashboard} path='dashboard' />
      <Redirect from='classes' to='usage-reports/classes' />
      <Redirect from='teachers' to='usage-reports/teachers' />
      <Redirect from='licenses' to='manage-staff' />
      <Route component={SchoolAdminManageStaff} path='manage-staff'>
        <IndexRedirect to='pending-approval' />
        <Route component={SchoolAdminPendingApprovalStaff} path='pending-approval' />
        <Route component={SchoolAdminPendingInvitationsStaff} path='pending-invitations' />
        <Route component={SchoolAdminApprovedStaff} path='approved' />
        <Route component={SchoolAdminRejectedStaff} path='rejected' />
      </Route>
      <Route component={SchoolAdminUpdateTeachers} path='update-teachers' withWhiteBackground />
      <Route component={SchoolAdminUsageReports} path='usage-reports'>
        <IndexRedirect to='teachers' />
        <Route path='teachers' component={SchoolAdminTeachersReport} />
        <Route path='students' component={SchoolAdminStudentsReport} />
        <Route path='classes' component={SchoolAdminClassesReport} />
        <Route path='subjects' component={SchoolAdminSubjectsReport} />
      </Route>
      <Route component={SchoolAccounts} path='school-accounts' withWhiteBackground />
      <Route component={CreateAccounts} path='create-accounts' withWhiteBackground />
    </Route>
  </Route>
);
